import { render, staticRenderFns } from "./AccountLimitsForm.vue?vue&type=template&id=98aad3d8&"
import script from "./AccountLimitsForm.vue?vue&type=script&lang=ts&"
export * from "./AccountLimitsForm.vue?vue&type=script&lang=ts&"
import style0 from "./AccountLimitsForm.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports